import { modelTestCopy as copy } from './copy'

export function ModelResponseError({
  message,
  partial,
}: {
  message: string
  partial: boolean
}) {
  return (
    <div
      role="alert"
      className="mt-3 border-l-2 border-amber-500 pl-3 text-sm text-amber-900 dark:text-amber-200"
    >
      <p className="font-medium">{partial ? copy.incomplete : copy.failed}</p>
      <p className="mt-1">{message}</p>
    </div>
  )
}
